import styled from 'styled-components';
import Button from '../Button';
import { CgMenuBoxed } from 'react-icons/cg';
import { RiPencilFill } from 'react-icons/ri';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import { primaryColor, textGrey, accentColor, accentTextColor } from '../../config/colors';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 2rem;
  position: relative;
  right: ${({ isOpened }) => (isOpened ? '-200px' : '0rem')};
  transition: right 0.5s ease-out;
  overflow-y: auto;
  // ::-webkit-scrollbar,
  // ::-webkit-scrollbar-thumb {
  //   display: none;
  // }
  > *:not(.table-wrapper) {
    padding-left: 2.5rem;
  }

  & > .table-wrapper {
    margin-left: 50px;
    width: calc(100% - 50px);

    ${({ isSideMenuCollapsed }) =>
      !isSideMenuCollapsed &&
      ` 
    margin-left: 200px;
    width: calc(100% - 450px);
    `}
  }

  & > .status-legend-wrapper {
    ${({ isSideMenuCollapsed }) =>
      !isSideMenuCollapsed &&
      `
    margin-left: 200px;
    width: calc(100% - 450px);
  `}
  }
`;

export const RightSideMenuWrapper = styled.div`
  position: absolute;
  top: 0;
  right: ${({ isOpened }) => (isOpened ? 0 : '-370px')};
  height: 100%;
  padding-left: 1rem;
  transition: right 0.5s ease-out;
  background-color: white;
  z-index: 1001;
`;

export const MenuIconBtn = styled(Button).attrs(() => ({
  wrapperStyle: {
    width: '2.375rem',
    height: '2.375rem',
    top: '3rem',
    left: '-1.5rem',
    position: 'absolute',
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    boxShadow: '-4px 3px 15px 0px rgba(0, 0, 0, 0.1)',
  },
  icon: CgMenuBoxed,
  iconProps: {
    color: primaryColor,
    size: '2rem',
  },
}))``;

export const Row = styled.div`
  width: ${({ width }) => width ?? '100%'};
  height: ${({ height }) => height};
  display: flex;
  align-items: ${({ alignItems }) => alignItems || 'center'};
  justify-content: ${({ justify }) => justify || 'space-between'};
  margin-bottom: ${({ marginBottom }) => marginBottom ?? 0};
  margin-top: ${({ marginTop }) => marginTop ?? 0};
  .checkbox {
    margin-right: 0.5rem;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  :not(:last-of-type) {
    margin-right: 1rem;
  }
`;

export const EditBtn = styled(Button).attrs(({ wrapperStyle = {} }) => ({
  wrapperStyle: {
    width: 'auto',
    height: 'auto',
    ...wrapperStyle,
  },
  type: 'transparentBackgroundButton',
  icon: RiPencilFill,
  iconProps: {
    color: primaryColor,
    fill: primaryColor,
    size: '1.6rem',
  },
}))``;

export const InfoBtn = styled(Button).attrs(({ wrapperStyle = {} }) => ({
  wrapperStyle: {
    width: 'auto',
    height: 'auto',
    ...wrapperStyle,
  },
  type: 'transparentBackgroundButton',
  icon: BsFillInfoCircleFill,
  iconProps: {
    color: primaryColor,
    fill: primaryColor,
    size: '1.6rem',
  },
}))``;

export const ActionBtnsWrapper = styled.div`
  > *:not(:last-child) {
    margin-bottom: 5px;
  }
`;

export const ActionBtnsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
  position: relative;
  left: -100px;
  > *:not(:last-child) {
    margin-right: 5px;
  }
`;

export const StyledActionBtn = styled(Button).attrs(({ wrapperStyle = {}, width = '100px' }) => ({
  wrapperStyle: {
    width: width,
    ...wrapperStyle,
  },
}))``;

export const LayoutListTitle = styled.h2`
  text-align: center;
  margin-top: 0.25rem;
  margin-bottom: 3rem;
  flex: 8;
`;

export const TableWrapper = styled.div`
  max-width: 100%;
`;

export const StatusDot = styled.span`
  width: ${({ size }) => size ?? '0.875rem'};
  height: ${({ size }) => size ?? '0.875rem'};
  border-radius: 50%;
  margin-right: 0.75rem;
  background-color: ${({ color }) => color};
  outline: 1px solid ${textGrey};
`;

export const LayoutWrapper = styled.div`
  margin: 5rem 0;
`;

export const Explanation = styled.div`
  text-align: center;
  margin: 0em auto 2em auto;
  width: 40%;
`;

export const TrainingBar = styled.div`
  background-color: ${accentColor};
  text-align: center;
  color: ${accentTextColor};
  font-size: smaller;
  padding: 3px;
  font-weight: bold;
  position: sticky;
  top: 0px;
  z-index: 999;
`;

export const ProjectWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LayoutTableTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
